import { render, staticRenderFns } from "./inputData.vue?vue&type=template&id=8ca7590e&scoped=true"
import script from "./inputData.vue?vue&type=script&lang=js"
export * from "./inputData.vue?vue&type=script&lang=js"
import style0 from "./inputData.vue?vue&type=style&index=0&id=8ca7590e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca7590e",
  null
  
)

export default component.exports